import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
import { useResponsive } from 'src/hooks/use-responsive';
// components
import { useSettingsContext } from 'src/components/settings';
import { usePathname } from 'src/routes/hooks';
import { matchPath, useLocation } from 'react-router-dom';
import Main from './main';
import Header from './header';
import NavMini from './nav-mini';
import NavVertical from './nav-vertical';
import NavHorizontal from './nav-horizontal';
import { LoadingScreen } from 'src/components/loading-screen';
import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorBoundaryFallback from 'src/sections/error/error-boundary-fallback';
import MobileView from 'src/sections/mobile-view';

const verticalNavbarPaths = [
  '/dashboard/jobs',
  '/dashboard/reports',
  '/dashboard/candidates',
  '/dashboard/message',
  '/dashboard/settings',
  '/dashboard/settings/organization',
  '/dashboard/settings/teams',
  '/dashboard/settings/notification',
  '/dashboard/settings/workflow-automation',
  '/dashboard/jobs/:id/candidates',
];

export default function DashboardLayout({ children }) {
  const settings = useSettingsContext();

  const mdUp = useResponsive('up', 'md');

  const nav = useBoolean();

  const pathname = usePathname();

  const isHorizontal = settings.themeLayout === 'horizontal';

  const isMini = settings.themeLayout === 'mini';

  const renderNavMini = <NavMini />;

  const renderHorizontal = <NavHorizontal />;

  const renderNavVertical = (
    <NavVertical openNav={nav.value} onCloseNav={nav.onFalse} />
  );

  const shouldShowNavbar = verticalNavbarPaths.some(path =>
    Boolean(matchPath({ path }, pathname)),
  );

  const location = useLocation();

  return mdUp ? (
    <>
      {/* <Header onOpenNav={nav.onTrue} /> */}

      <Box
        sx={{
          minHeight: 1,
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
        }}
      >
        {shouldShowNavbar && renderNavVertical}

        <Suspense fallback={<LoadingScreen />}>
          <ErrorBoundary
            key={location.key}
            FallbackComponent={ErrorBoundaryFallback}
          >
            <Main>{children}</Main>
          </ErrorBoundary>
        </Suspense>
      </Box>
    </>
  ) : (
    <MobileView />
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node,
};
